import styled from 'styled-components'

export const Link = styled.div`
  a{
    text-decoration: none;
    color: white;

  }
`
